var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 12,
    viewBox: "0 0 170 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xD0\xA0\xD0\xB5\xD1\x81\xD1\x83\xD1\x80\xD1\x81 1 1",
    clipPath: "url(#clip0_733_1846)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xD0\xA1\xD0\xBB\xD0\xBE\xD0\xB9 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xD0\xA1\xD0\xBB\xD0\xBE\xD0\xB9 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.81055 9.23359C3.99274 9.23359 2.78795 8.23789 2.78795 5.98264C2.78795 3.72739 3.98278 2.76655 6.81055 2.76655C9.13052 2.76655 10.4747 3.4486 10.7386 5.19604H13.5713C13.2925 2.06956 11.1269 0.431641 6.81055 0.431641C2.04118 0.431641 0 2.39316 0 5.98264C0 9.57212 2.04118 11.5685 6.81055 11.5685C11.1269 11.5685 13.2826 9.91564 13.5713 6.77422H10.7386C10.4548 8.5366 9.11559 9.23359 6.81055 9.23359Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.0996 0.585938H18.3359L12.75 11.4141H15.8167L16.9767 9.10909H23.4487L24.6087 11.4141H27.6904L22.0996 0.585938ZM18.0122 7.05796L20.2277 2.66196L22.4033 7.03804L18.0122 7.05796Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M39.5387 0.585938V8.72575L32.1407 0.585938H28.377V11.4141H31.1599V3.29423L38.533 11.4141H42.3167V0.585938H39.5387Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M54.7342 0.585938V8.72575L47.3362 0.585938H43.5625V11.4141H46.3455V3.29423L53.7285 11.4141H57.5172V0.585938H54.7342Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M85.7004 5.53473C86.2355 4.95865 86.5387 4.20505 86.5517 3.41888C86.5517 1.82577 85.79 0.576172 83.3307 0.576172H73.7969V11.4143H83.704C86.1634 11.4143 87.2288 10.0851 87.2288 8.25796C87.2413 7.70876 87.1061 7.16629 86.8372 6.68724C86.5683 6.20819 86.1757 5.81015 85.7004 5.53473ZM76.5848 2.59743H82.325C83.0817 2.59743 83.7638 2.59743 83.7638 3.70763C83.7638 4.81783 83.0817 4.83775 82.3399 4.83775H76.5848V2.59743ZM83.022 9.26361H76.5848V6.97351H83.022C83.7638 6.97351 84.4458 6.97351 84.4458 8.11856C84.4458 9.26361 83.7638 9.26361 83.022 9.26361V9.26361Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M99.595 2.79638V0.585938H88.1445V11.4141H99.595V9.20368H90.9275V7.00817H99.595V4.99189H90.9275V2.79638H99.595Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M100.352 0.585938V2.92084H105.614V11.4141H108.397V2.92084H113.659V0.585938H100.352Z",
    fill: "#010D00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M127.23 4.55895C127.23 2.14937 125.542 0.576172 123.082 0.576172H114.574V11.4143H117.357V8.52182H121.838L123.585 11.4143H126.866L124.875 8.19822C125.601 7.91709 126.219 7.41384 126.642 6.76029C127.065 6.10674 127.271 5.3363 127.23 4.55895V4.55895ZM122.311 6.18691H117.332V2.92103H122.311C123.147 2.92103 124.461 2.92103 124.461 4.55895C124.461 6.19687 123.147 6.18691 122.311 6.18691V6.18691Z",
    fill: "#010D00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M139.069 0.585938V5.9826C139.069 7.47615 138.651 9.23355 135.047 9.23355C131.442 9.23355 131.024 7.50104 131.024 5.9826V0.585938H128.236V5.9826C128.236 9.76127 130.282 11.5685 135.047 11.5685C139.811 11.5685 141.852 9.74633 141.852 5.9826V0.585938H139.069Z",
    fill: "#010D00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M149.778 4.91257C146.622 4.72339 145.969 4.56906 145.969 3.73268C145.969 2.89629 146.622 2.66728 149.36 2.66728C152.252 2.66728 153.447 2.96101 153.447 4.16082H156.23C156.23 1.48738 153.741 0.466797 149.668 0.466797C145.596 0.466797 143.196 1.22352 143.196 3.60324C143.196 5.98295 145.068 6.7795 149.788 6.99358C153.273 7.16285 153.92 7.31718 153.92 8.21828C153.92 9.11939 153.039 9.3932 150.112 9.3932C146.587 9.3932 145.656 8.86548 145.656 7.72043H142.883C142.883 10.8469 145.526 11.6036 149.967 11.6036C153.975 11.6036 156.713 11.0162 156.713 8.11871C156.693 5.35068 154.05 5.11669 149.778 4.91257Z",
    fill: "#010D00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M156.693 0.585938V2.92084H161.956V11.4141H164.744V2.92084H170.001V0.585938H156.693Z",
    fill: "#010D00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M65.4325 10.0104C65.4878 9.87465 65.5562 9.7446 65.6366 9.62207L65.6068 11.4143H64.4219C64.8865 11.053 65.2373 10.5657 65.4325 10.0104Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M64.5701 8.93001C64.9398 9.09932 65.2975 9.29395 65.6404 9.51249V9.51249C65.4861 9.47764 65.0032 9.3482 64.824 9.2785C62.8625 8.47199 60.5773 8.93997 59.3477 9.2785L60.8711 6.32129C61.8634 7.48996 63.1361 8.38757 64.5701 8.93001V8.93001Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M64.8246 9.79658C65.0922 9.70198 65.3647 9.62221 65.6411 9.55762V9.55762C65.5104 9.64756 65.3702 9.7227 65.2229 9.78165C64.4207 10.0758 63.7521 10.6506 63.341 11.3997H58.248L59.1043 9.73186C60.2394 10.1152 62.5345 10.7674 64.8246 9.79658Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M65.2971 8.19764C65.4393 8.57045 65.5541 8.95315 65.6406 9.34269V9.46218C65.5161 9.2481 65.1776 8.6706 65.078 8.42665C64.4472 6.76239 63.356 5.31195 61.9316 4.24473L63.8085 0.605469H65.0432C64.4756 2.67154 63.9529 5.4545 65.2971 8.19764Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M66.9649 11.4146H65.7701L65.7402 9.60742C65.8249 9.73434 65.8966 9.86944 65.9543 10.0107C66.1529 10.5641 66.5031 11.0506 66.9649 11.4146V11.4146Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M66.3142 8.42665C66.1337 8.78708 65.9343 9.13772 65.7168 9.47711V9.33274C65.7958 8.94452 65.9108 8.56451 66.0603 8.19764C67.4493 5.70841 66.8967 2.77111 66.3092 0.605469H67.5439L69.4307 4.24971C68.0195 5.32102 66.9393 6.76881 66.3142 8.42665V8.42665Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M66.8154 8.92972C68.2526 8.39533 69.5293 7.50248 70.5244 6.33594L72.0527 9.28817C70.8081 8.94964 68.528 8.49162 66.5764 9.28817C66.3922 9.36285 65.8894 9.49229 65.75 9.52714C66.0915 9.30453 66.4474 9.10495 66.8154 8.92972V8.92972Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M73.1532 11.4144H68.0502C67.6377 10.6665 66.9697 10.0921 66.1684 9.79639C66.0187 9.73391 65.8753 9.65722 65.7402 9.56738V9.56738C66.02 9.6334 66.2959 9.71484 66.5667 9.81133C68.8568 10.807 71.1568 10.13 72.2919 9.76154L73.1532 11.4144Z",
    fill: "#4FA778"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_733_1846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 11.1368,
    fill: "white",
    transform: "translate(0 0.431641)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo3);
export default __webpack_public_path__ + "static/media/logo-3.d4fc796d2d2d29d20fa7a49969ec355a.svg";
export { ForwardRef as ReactComponent };